export default __webpack_public_path__ + "static/media/feedback.7181809f.svg";